import { Button, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PiFolderOpenThin } from "react-icons/pi";
import { BsGear, BsHeadset, BsCalculator } from "react-icons/bs";
import { GrInfo } from "react-icons/gr";
import { FaRegBell } from "react-icons/fa";
import { MdOutlineTune, MdOutlineTextFields } from "react-icons/md";
import { SlSizeFullscreen } from "react-icons/sl";
import { BiTask } from "react-icons/bi";
import { GrGroup } from "react-icons/gr";
import { IoCalendarOutline } from "react-icons/io5";
import { TfiEmail } from "react-icons/tfi";
import { useSelector } from 'react-redux';
import FullScreenToggle from './fullScreenToggle/FullScreenToggle';

const GetHeaderButtonByName = ({ name, index }) => {
    const isFullScreen = useSelector(state => state.lc.isFullScreen);
    // const unreadAlertsCounter = useSelector(state => state.alerts.unreadAlertsCounter);
    // const unreadMailsCounter = useSelector(state => state.mailbox.unreadMailsCounter);
    const unreadAlertsCounter = 5;
    const unreadMailsCounter = 3;
    const handleMailboxSideModalShow = () => { };
    const handleAlertsSideModalShow = () => { };
    const handleCalculatorShow = () => { };

    switch (name) {
        case 'tips':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><GrInfo style={{ fontSize: '20px' }} /></div>
            </Button>;
        case 'filesManager':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><PiFolderOpenThin style={{ fontSize: '24px' }} /></div>
            </Button>;
        case 'mailBox':
            return <Button key={index} variant="outline-secondary icon-button pos-rel" onClick={handleMailboxSideModalShow}>
                <div><TfiEmail /></div>
                <Badge bg="" className="my-badge">{unreadMailsCounter}</Badge>
            </Button>;
        case 'alerts':
            return <Button key={index} variant="outline-secondary icon-button pos-rel" onClick={handleAlertsSideModalShow}>
                <div><FaRegBell /></div>
                <Badge bg="" className="my-badge">{unreadAlertsCounter}</Badge>
            </Button>;
        case 'calendar':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><IoCalendarOutline /></div>
            </Button>;
        case 'contacts':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><GrGroup /></div>
            </Button>;
        case 'tasks':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><BiTask /></div>
            </Button>;
        case 'calculator':
            return <Button key={index} variant="outline-secondary icon-button" onClick={handleCalculatorShow}>
                <div><BsCalculator /></div>
            </Button>;
        case 'fontSize':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><MdOutlineTextFields /></div>
            </Button>;
        case 'fullScreen':
            return <FullScreenToggle key={index}>
                <Button key={index} variant="outline-secondary icon-button" style={{ color: (isFullScreen ? '#edc282' : '') }}>
                    <div><SlSizeFullscreen /></div>
                </Button>
            </FullScreenToggle>;
        case 'support':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><BsHeadset /></div>
            </Button>;
        case 'systemConfig':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><BsGear /></div>
            </Button>;
        case 'deepSearch':
            return <Button key={index} variant="outline-secondary icon-button">
                <div><MdOutlineTune /></div>
            </Button>;
        default:
            return '';
    }
}

export default GetHeaderButtonByName;